module.exports = __webpack_public_path__ + "static/img/activity-20240424.b4756c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity-20240424.png
// module id = H8Ne
// module chunks = 0